var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F8F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12H27C27.55 12 28 12.45 28 13V27C28 27.55 27.55 28 27 28H25C24.45 28 24 27.55 24 27C24 26.45 24.45 26 25 26H26V14H25C24.45 14 24 13.55 24 13C24 12.45 24.45 12 25 12ZM18.3998 15.2004C18.8438 14.8694 19.4688 14.9594 19.7998 15.4004L22.7998 19.4004C23.0598 19.7464 23.0678 20.2204 22.8178 20.5754L20.0038 24.5754C19.8088 24.8524 19.4998 25.0004 19.1848 25.0004C18.9868 25.0004 18.7858 24.9414 18.6108 24.8184C18.1588 24.5004 18.0498 23.8764 18.3678 23.4244L20.0858 20.9824C20.0723 20.9837 20.0596 20.9875 20.047 20.9913C20.0316 20.9958 20.0163 21.0004 19.9998 21.0004H11.9998C11.4478 21.0004 10.9998 20.5524 10.9998 20.0004C10.9998 19.4474 11.4478 19.0004 11.9998 19.0004H19.9998H20.0008L18.1998 16.5994C17.8688 16.1584 17.9578 15.5314 18.3998 15.2004Z",
    fill: "#19262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/LoginIcon.df3dc0b93871ed3fb0d3e86da30bcef9.svg";
export { ForwardRef as ReactComponent };